import React, { useEffect, useState } from "react";
import Button from "../../../components/FormComponents/Button";
import { addNewSection, addNewSectionAtTop, expandToSelectedItem, moveSelectedItem } from "../utils";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { usePositionedScreenContext } from "../PositionedScreen";
import TreeNode from "./TreeNode";

const TreeView = () => {
  const { layoutConfig, selectedItem, selectedItemPath, type, setLayoutConfig, setSelectedItem } =
    usePositionedScreenContext();
  const [isExpandedGlobal, setIsExpandedGlobal] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState([]);

  const handleExpandAll = () => {
    setIsExpandedGlobal((prev) => !prev);
    setExpandedNodes([]);
  };

  const handleAddNewSection = () => {
    addNewSection(type, layoutConfig, setLayoutConfig, setSelectedItem);
  };

  const handleAddNewSectionAtTop = () => {
    addNewSectionAtTop(type, layoutConfig, setLayoutConfig, setSelectedItem);
  };

  const handleMoveElements = (index, level, options) => {
    const newLayout = moveSelectedItem(layoutConfig, options.node, options.direction);
    setLayoutConfig(newLayout);
  };

  useEffect(() => {
    const path = expandToSelectedItem(selectedItem, layoutConfig, [], { path: selectedItemPath });
    if (path) setExpandedNodes(path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  const renderTree = (data, level = 0, path) => {
    return (
      <ul style={{ listStyleType: "none", paddingLeft: 0, marginBottom: 4 }}>
        {data.map((node, index) => (
          <TreeNode
            key={node.id}
            moveElements={(options) => handleMoveElements(index, level, options)}
            node={node}
            level={level}
            index={index}
            length={data.length}
            renderTree={renderTree}
            isExpandedGlobal={isExpandedGlobal}
            expandedNodes={expandedNodes}
            path={path}
          />
        ))}
      </ul>
    );
  };

  return (
    <div className="bg_light h_100 overflow_scroll" style={{ padding: "12px" }}>
      <div className="d_flex align_center space_between">
        <Button onClick={handleExpandAll} variant="secondary" style={{ marginBottom: "12px", fontWeight: 500 }}>
          <MaterialIcon name={isExpandedGlobal ? "unfold_less" : "unfold_more"} />
          {isExpandedGlobal ? "Collapse All" : "Expand All"}
        </Button>
        <div className="d_flex gap_2">
          <Button
            onClick={handleAddNewSectionAtTop}
            variant="secondary"
            style={{ marginBottom: "12px", fontWeight: 500, width: "120px" }}
          >
            +T Section
          </Button>
          <Button
            onClick={handleAddNewSection}
            variant="secondary"
            style={{ marginBottom: "12px", fontWeight: 500, width: "120px" }}
          >
            +B Section
          </Button>
        </div>
      </div>

      {renderTree(layoutConfig)}
    </div>
  );
};

export default TreeView;
